import { useState, useEffect } from "react";
import { useDebounce } from "use-debounce";
import { useNavigate } from "react-router-dom";

import { BASE_URL } from "../config/constants";

const Users = () => {
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 300);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const fetchUsers = async () => {
    setLoading(true);
    setError(null); // إعادة ضبط الخطأ قبل كل محاولة جلب
    try {
      const res = await fetch(
        `${BASE_URL}api/v1/users?limit=1000&filters=${debouncedSearch || ""}`
      );

      if (res.status === 404) {
        setError("المستخدمين غير موجودين (404)");
        setUsers([]);
        return;
      }

      if (!res.ok) throw new Error("حدث خطأ أثناء تحميل البيانات");

      const data = await res.json();
      setUsers(data.data || []);
    } catch (err) {
      console.error("خطأ في جلب المستخدمين:", err);
      setError("حدث خطأ أثناء تحميل البيانات");
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [debouncedSearch]);

  return (
    <div className="min-h-screen bg-gray-50 px-6 py-12 mt-24">
      <div className="text-center mb-10">
        <h1 className="text-3xl md:text-4xl font-bold text-blue-800">
          مجتمع سكيما
        </h1>
        <p className="text-gray-700 mt-2">
          انضم إلى مجتمع تفاعلي يشاركك الشغف بالذكاء الاصطناعي وعلوم البيانات.
        </p>

        <div className="mt-6 flex justify-center">
          <input
            type="text"
            placeholder="ابحث عن الأعضاء"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full max-w-xl px-4 py-3 rounded-lg border-2 border-blue-300 bg-transparent placeholder-blue-400 text-blue-900 focus:outline-none"
          />
        </div>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {Array.from({ length: 12 }).map((_, i) => (
            <div
              key={i}
              className="animate-pulse bg-white rounded-lg shadow p-6 h-24"
            />
          ))}
        </div>
      ) : error ? (
        <div className="text-center py-12">
          <p className="text-red-500 text-lg font-semibold">{error}</p>
        </div>
      ) : users.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-blue-800 text-lg font-semibold">
            {search
              ? "لا يوجد أعضاء مطابقين لبحثك"
              : "لا يوجد أعضاء متاحين حالياً"}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {users.map((user) => (
            <div
              key={user.id}
              onClick={() => navigate(`/users/${user.id}`)}
              className="bg-white rounded-lg shadow p-4 text-center cursor-pointer hover:shadow-lg transition"
            >
              <p className="text-lg font-semibold text-blue-800">
                {user.firstName} {user.lastName}
              </p>
              <p className="text-sm text-gray-500">{user.role?.name}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Users;
